<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="green"
          icon="mdi-currency-inr"
          title="Sales"
          :value="sales"
          value-icon="mdi-currency-inr"
          sub-icon="mdi-calendar"
          sub-text="Today"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="primary"
          icon="mdi-cart-plus"
          title="New Orders"
          :value="pending"
          sub-icon="mdi-calendar"
          sub-text="Today"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="red"
          icon="mdi-truck-delivery"
          title="Pending Delivery"
          :value="pendingDelivery"
          sub-icon="mdi-calendar"
          sub-text="Today"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="info"
          icon="mdi-cart-off"
          title="Cancelled"
          :value="cancelled"
          sub-icon="mdi-calendar"
          sub-text="Today"
        />
      </v-flex>
      <v-flex md12 lg6>
        <!-- <material-card
          color="primary"
          title="Delivery Boy Stats"
          text="Todays Delivery Stats"
        >
          <v-data-table
            :headers="headers"
            :items="delivery_stats"
            hide-actions
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td class="text-xs-right">{{ item.pending }}</td>
              <td class="text-xs-right">{{ item.delivered }}</td>
              <td class="text-xs-right">Rs.{{ item.earning }}</td>
            </template>
          </v-data-table>
        </material-card> -->
        <!-- <material-card 
          color="red lighten-3"
          title="Holiday Calendar"
      >
      
        <v-date-picker
        full-width
        :events="holidays"
        event-color="red"
        class="mt-3"
        @click:date="addHoliday($event)"
      >
        
      </v-date-picker>
      <v-progress-linear
            color="green"
            class="ma-0"
            height="4"
            indeterminate
            :active="holidayProgress"
          ></v-progress-linear>
      </material-card> -->
      </v-flex>
      <v-flex md12 lg12>
        <material-card class="card-tabs" color="green">
          <v-flex slot="header">
            <v-tabs v-model="tabs" color="transparent" slider-color="white">
              <span
                class="subheading font-weight-light mr-3"
                style="align-self: center"
                >Orders:</span
              >
              <v-tab class="mr-3">
                New
              </v-tab>
              <v-tab class="mr-3">
                Delivered
              </v-tab>
              <v-tab>
                Cancelled
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-list two-line>
                <template v-for="(order, index) in Orders.pending">
                  <v-list-tile :key="order.tracking_id">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text--primary"
                        v-text="'#' + order.tracking_id"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        class="text--primary"
                        v-text="order.items + ' items'"
                      ></v-list-tile-sub-title>

                      <v-list-tile-sub-title
                        v-text="
                          order.name +
                            ', ' +
                            order.flatNo +
                            ', ' +
                            order.apartment +
                            ', ' +
                            order.street +
                            ', ' +
                            order.city
                        "
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-list-tile-action-text
                        v-text="'Rs.' + order.total"
                      ></v-list-tile-action-text>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="index < items.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list two-line>
                <template v-for="(order, index) in Orders.delivered">
                  <v-list-tile :key="order.tracking_id">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text--primary"
                        v-text="'#' + order.tracking_id"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        class="text--primary"
                        v-text="order.items + ' items'"
                      ></v-list-tile-sub-title>

                      <v-list-tile-sub-title
                        v-text="
                          order.name +
                            ', ' +
                            order.flatNo +
                            ', ' +
                            order.apartment +
                            ', ' +
                            order.street +
                            ', ' +
                            order.city
                        "
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-list-tile-action-text
                        v-text="'Rs.' + order.total"
                      ></v-list-tile-action-text>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="index < items.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </v-tab-item>
            <v-tab-item>
              <v-list two-line>
                <template v-for="(order, index) in Orders.cancelled">
                  <v-list-tile :key="order.tracking_id">
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="text--primary"
                        v-text="'#' + order.tracking_id"
                      ></v-list-tile-title>
                      <v-list-tile-sub-title
                        class="text--primary"
                        v-text="order.items + ' items'"
                      ></v-list-tile-sub-title>

                      <v-list-tile-sub-title
                        v-text="
                          order.name +
                            ', ' +
                            order.flatNo +
                            ', ' +
                            order.apartment +
                            ', ' +
                            order.street +
                            ', ' +
                            order.city
                        "
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-list-tile-action-text
                        v-text="'Rs.' + order.total"
                      ></v-list-tile-action-text>
                    </v-list-tile-action>
                  </v-list-tile>
                  <v-divider
                    v-if="index < items.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style type="text/css">
.v-date-picker-header {
  display: none;
}
</style>
<script>
import api from '@/api';
export default {
  data() {
    return {
      delivery_stats: [],
      stats: {},
      expand: false,
      holidayProgress: false,
      headers: [
        {
          sortable: false,
          text: 'ID',
          value: 'id',
        },
        {
          sortable: false,
          text: 'Name',
          value: 'name',
        },
        {
          sortable: false,
          text: 'Pending',
          value: 'salary',
          align: 'right',
        },
        {
          sortable: false,
          text: 'Delivered',
          value: 'country',
          align: 'right',
        },
        {
          sortable: false,
          text: 'Amount Earned',
          value: 'city',
          align: 'right',
        },
      ],
      items: [],
      tabs: 0,
      Orders: {},
      list: {
        0: false,
        1: false,
        2: false,
      },
    };
  },
  watch: {
    vid() {
      this.reload();
    },
  },
  computed: {
    vid() {
      return this.$store.state.vid;
    },
    sales() {
      if (this.Orders.delivered)
        return this.Orders.delivered.reduce(
          (result, val) => result + val.total,
          0,
        );
      return 0;
    },
    pending() {
      if (this.Orders.pending) {
        console.log(this.Orders.pending.length);
        return this.Orders.pending.length;
      }
      return 0;
    },
    cancelled() {
      if (this.Orders.cancelled) return this.Orders.cancelled.length;
      return 0;
    },
    delivered() {
      if (this.Orders.delivered) return this.Orders.delivered.length;
      return 0;
    },
    pendingDelivery() {
      if (this.Orders.pendingDelivery)
        return this.Orders.pendingDelivery.length;
      return 0;
    },
    config: {
      get() {
        return this.$store.state.vendors.find(v => this.vid == v.id);
      },
      set(c) {
        this.$set(
          this.$store.state.vendors,
          this.$store.state.vendors.findIndex(v => this.vid == v.id),
          c,
        );
      },
    },
    holidays: {
      get() {
        if (this.config) return this.config.holidays;
        return [];
      },
      set(h) {
        this.config.holidays = h;
      },
    },
  },
  mounted: function() {
    this.expand = true;
    if (this.vid) this.reload();
  },
  methods: {
    complete(index) {
      this.list[index] = !this.list[index];
    },
    addHoliday(d) {
      var i = this.holidays.findIndex(e => e == d);
      if (i > -1) this.holidays.splice(i, 1);
      else this.holidays.push(d);
      this.holidayProgress = true;
      api
        .post('config/update', this.config)
        .then(r => {
          this.config = r.data.config;
          this.holidayProgress = false;
        })
        .catch(async err => {
          this.holidayProgress = false;
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              var i = this.holidays.findIndex(e => e == d);
              if (i > -1) this.holidays.splice(i, 1);
              else this.holidays.push(d);
            }
          }
        });
    },
    reload() {
      let loader = this.$loading.show();
      api
        .get('orders/dashboard/')
        .then(r => {
          this.delivery_stats = r.data.delivery_boy_stats;
          this.Orders = r.data.orders;
          loader.hide();
        })
        .catch(async err => {
          loader.hide();
          if (err.message == 'Network Error') {
            const res = await this.$dialog.confirm({
              text: 'Please check your internet connection and try again',
              title: 'Connection Failed',
              actions: [
                { text: 'Cancel', color: 'primary', key: false },
                { text: 'Retry', color: 'primary', key: true },
              ],
            });
            if (res) {
              this.reload();
            }
          }
        });
    },
  },
};
</script>
